export const cardData = [
    {
        client:'Hitpost',
        title:'PROCESS PEOPLE',
        description:'The Sights Studios team worked closely with Caleb at Hitpost, providing coaching on sales tactics and closing strategies. With our guidance, he was able to 2x his client base by implementing practical solutions that led to immediate results and a significant boost in his business.',
        image:'/photos/client-photos/hitpost-homepage.webp',
        url: 'https://www.hitpost.co/'
    },
  {
    client:'FIRM Israel',
    title:'PROCESS PRODUCT',
    description:'Our team at Sights Studios partnered with Firm to refine their CRM strategy and develop a streamlined workflow. These processes are designed to be automated for long-term efficiency, enabling their donor development team to scale and hire additional staff, ultimately supporting rapid team growth.',
    image:'/photos/client-photos/firm-homepage.webp',
        url: 'https://www.firm.org.il/'
},

{
    client:'Big Fan Pros',
    title:'PROCESS PRODUCT',
    description:'Sights Studios was instrumental in establishing Big Fan Pros online presence. We built their website from the ground up and developed comprehensive strategies for increasing sales and marketing. Through our collaborative approach, we helped them strengthen their digital presence and create sustainable growth processes.',
    image:'/photos/client-photos/bigfanpros.webp',
        url: 'https://www.bigfanpros.com/'
},
{
    client:'MAP 1040',
    title:'PRODUCT PEOPLE',
    description:'The Sights Studios team created a full digital presence for MAP1040, including their website, marketing strategy, communication plan, and engagement framework. Our efforts resulted in expanded reach and new donors, allowing MAP1040 to increase its influence and support.',
    image:'/photos/client-photos/MAP1040-homepage.webp',
        url: 'https://www.map1040.com/'
},/* 
{
    client:'Tarifa - Spain',
    title:'LOS LANCES',
    title2:'BEACH',
    description:'Los Lances Beach in Tarifa is a coastal paradise known for its consistent winds, making it a world-renowned spot for kitesurfing and windsurfing. The beach\'s long, sandy shores provide ample space for relaxation and sunbathing, with a vibrant atmosphere of beach bars and cafes.',
    image:'https://assets.codepen.io/3685267/timed-cards-5.jpg',
        url: 'https://www.firm.org.il/'
},
{
    client:'Cappadocia - Turkey',
    title:'Göreme',
    title2:'Valley',
    description:'Göreme Valley in Cappadocia is a historical marvel set against a unique geological backdrop, where centuries of wind and water have sculpted the landscape into whimsical formations. The valley is also famous for its open-air museums, underground cities, and the enchanting experience of hot air ballooning.',
    image:'https://assets.codepen.io/3685267/timed-cards-6.jpg',
        url: 'https://www.firm.org.il/'
}, */
];